import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import BackNavbarLearning from '../../../ReusableBlocks/Navbar'
import Footer from '../../../ReusableBlocks/FooterBlock'
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchLearningHub } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import Modal from 'react-bootstrap/Modal';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import * as PATH from '../../../CentralisedLink'
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';

const MicroCerts = (props) => {

    const secretKey = 'micro';

    const encryptId = (id) => {
        const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
        return encodeURIComponent(ciphertext);
    };


    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('suggested');
    const [track, setTrack] = useState(null);
    const { id } = useParams();

    const { getData } = useSelector((state) => state.LearningHubData);
    const [badgde, setbadgde] = useState('');
    const [badgeModel, setBadgdeModel] = useState(false)
    const handleShowBadgdeModel = (badge) => {
        setbadgde(badge)
        setBadgdeModel(true);
    }
    const handleCloseBadgdeModel = () => setBadgdeModel(false);

    useEffect(() => {
        dispatch(fetchLearningHub());
      }, [dispatch]);

    useEffect(() => {
        if (getData?.tracks) {
            const selectedTrack = getData?.tracks.find(track => track?.trackTitle === id);
            setTrack(selectedTrack);
        }
    }, [id, getData]);


    const isLoading = useSelector(state => state.LearningHubData?.loading);
    const errorMessage = useSelector(state => state.LearningHubData?.error);

    useEffect(() => {
        if (errorMessage) {
            Swal.fire({
                title: 'Error',
                text: errorMessage,
                icon: 'error',
                // confirmButtonText: 'Retry',
                showCancelButton: true,
                customClass: {
                    title: 'my-custom-title-of-pop-login',
                    confirmButton: 'my-custom-button-of-pop',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });;
        }
    }, [errorMessage]);


    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    const downloadBadge = (badgde) => {
        const link = document.createElement('a');
        link.href = badgde;
        window.open(badgde, '_blank');
    };

    const shareOnLinkedIn = (badgde) => {
        const badgeUrl = encodeURIComponent(badgde);
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${badgeUrl}`;
        window.open(linkedInUrl, '_blank');
    };


    const suggestedMicroCerts = track?.microcertsList?.filter(microcert => !microcert.questionStatus && !microcert.videoStatus);
    const progressMicroCerts = track?.microcertsList?.filter(microcert => !microcert.questionStatus && microcert.videoStatus);
    const completedMicroCerts = track?.microcertsList?.filter(microcert => microcert.questionStatus && microcert.videoStatus);





    const remainingTracks = getData?.tracks.filter((t) => t?.trackTitle !== id) || [];

    return (
        <>
            {isLoading && <LoadingScreen text="Loading..." />}


            <BackNavbarLearning activeTabSales={"LEARNING_HUB"}/>

            <section>
                <div className='learning-hub-micro-certs-hero-section'>
                    <div className='container'>
                        <div className='learning-hub-micro-certs-her-content'>
                            <h6 className='learning-hub-micro-certs-her-content-h1'>{track?.trackTitle}</h6>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className='tabs-search-sec'>
                    <div className='container'>
                        <div className='tabs-search-flex-one'>
                            <div className='tabs-search-flex-two'>
                                <div className={`tab ${activeTab === 'suggested' ? 'active' : ''}`} onClick={() => handleTabChange('suggested')}>
                                    <div className='lear-dis-flex'>
                                        <p className='sugges-p'>Suggested </p>
                                        <p className='sugges-p-count'>{suggestedMicroCerts?.length}</p>
                                    </div>
                                </div>
                                <div className={`tab ${activeTab === 'progress' ? 'active' : ''}`} onClick={() => handleTabChange('progress')}>
                                    <div className='lear-dis-flex'>
                                        <p className='sugges-p'>In Progress </p>
                                        <p className='sugges-p-count'>{progressMicroCerts?.length}</p>
                                    </div>
                                </div>
                                <div className={`tab ${activeTab === 'completed' ? 'active' : ''}`} onClick={() => handleTabChange('completed')}>
                                    <div className='lear-dis-flex'>
                                        <p className='sugges-p'>Completed </p>
                                        <p className='sugges-p-count'>{completedMicroCerts?.length}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='background-color'>
                <br />
                <div className='container'>
                    <div className="row">
                        
                        {activeTab === 'suggested' && (
                            suggestedMicroCerts?.length > 0 ? (
                                suggestedMicroCerts.map((microcert, index) => (
                                    <div className='col-sm-6 col-md-4 col-lg-3' key={`${microcert?.certId}-${index}`}>
                                        <div className='sub-course-card'>
                                            <div className='course-image-micro'>
                                                <img src={normalizeMediaUrl(microcert?.certThumnail, 'image')} loading="lazy" alt='Course Showcase' />
                                            </div>
                                            <div className='sub-course-details'>
                                                <h2 className='sub-course-name'>{microcert?.title}</h2>
                                                <div className='cour-dist'>
                                                    <p className='sub-course-dist-det'>
                                                        <span className='sub-cougrse-dist-det-one'>&#8226; {microcert?.completionTime}</span>
                                                        <span className='sub-course-dist-det-two'>&#8226; 1 Module</span>
                                                    </p>
                                                </div>
                                                <p className='sub-course-det-paragraph'>{microcert?.shortDescription}</p>
                                                <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${id}/${encryptId(microcert?.certId)}`}>
                                                    <p className='launch-button'>Launch now {'>>'}</p>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No suggested microcerts available.</p>
                            )
                        )}


                       
                        {activeTab === 'progress' && (
                            progressMicroCerts?.length > 0 ? (
                                progressMicroCerts.map((microcert, index) => (
                                    <div className='col-sm-6 col-md-4 col-lg-3' key={`${microcert?.certId}-${index}`}>
                                        <div className='sub-course-card'>
                                            <div className='course-image-micro'>
                                                <img src={normalizeMediaUrl(microcert?.certThumnail, 'image')} loading="lazy" alt='Course Showcase' />
                                            </div>
                                            <div className='sub-course-details'>
                                                <h2 className='sub-course-name'>{microcert?.title}</h2>
                                                <div className='cour-dist'>
                                                    <p className='sub-course-dist-det'>
                                                        <span className='sub-cougrse-dist-det-one'>&#8226; {microcert?.completionTime}</span>
                                                        <span className='sub-course-dist-det-two'>&#8226; 1 Module</span>
                                                    </p>
                                                </div>
                                                <p className='sub-course-det-paragraph'>{microcert?.shortDescription}</p>
                                                <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${id}/${encryptId(microcert?.certId)}`}>
                                                    <p className='launch-button'>Launch now {'>>'}</p>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No microcerts in progress.</p>
                            )
                        )}



                        
                        {activeTab === 'completed' && (
                            completedMicroCerts?.length > 0 ? (
                                completedMicroCerts.map((microcert, index) => (
                                    <div className='col-sm-6 col-md-4 col-lg-3' key={`${microcert?.certId}-${index}`}>
                                        <div className='sub-course-card-complted'>
                                            <div className='course-image-micro'>
                                                <img src={normalizeMediaUrl(microcert?.certThumnail, 'image')} loading="lazy" alt='Course Showcase' />
                                            </div>
                                            <div className='sub-course-details'>
                                                <h2 className='sub-course-name'>{microcert?.title}</h2>
                                                <div className='cour-dist'>
                                                    <p className='sub-course-dist-det'>
                                                        <span className='sub-cougrse-dist-det-one'>&#8226; {microcert?.completionTime}</span>
                                                        <span className='sub-course-dist-det-two'>&#8226; 1 Module</span>
                                                    </p>
                                                </div>

                                                <p className='sub-course-det-paragraph'>{microcert?.shortDescription}</p>
                                                <span className='sub-course-dist-det-two-status'>&#8226; Completed</span>
                                                <button className="badge-button" onClick={() => handleShowBadgdeModel(microcert?.completionBadge)}>View Badge</button>
                                                <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${id}/${encryptId(microcert?.certId)}`}>
                                                    <p className='micr-certs-view-course-btn'>View Course</p>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No completed microcerts available.</p>
                            )
                        )}


                    </div>

                    <br /><br />
                    <p className='available-tracks'>Available Tracks (2)</p>

                    {remainingTracks?.map((track) => (
                        <div className="course-card" key={track?.trackTitle}>
                            <div className="course-image">
                                <img src={normalizeMediaUrl(track?.thumbnail, 'image')} alt="Course Showcase" />
                            </div>
                            <div className="course-details">
                                <h1 className="training-title">{track?.trackTitle}</h1>
                                <div className="line-lear"></div>
                                <div className="cour-dist">
                                    <p className="course-dist-det">
                                        <span className="cougrse-dist-det-one">&#8226; {track?.totalDuration}</span>
                                        <span className="course-dist-det-two">&#8226; {track?.microcertsList.length} Microcerts</span>
                                    </p>
                                </div>
                                <p className="course-det-paragraph">{track?.trackDescription}</p>
                                <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.trackTitle}`}>
                                    <p className="launch-button">Launch now {'>>'}</p>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
                <br></br>
            </div>

            <br></br>

            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                show={badgeModel}
                onHide={() => handleCloseBadgdeModel()}
                fullscreen={false}
            >
                <Modal.Body className='badgde-body'>
                    <img className='badgde-cert' src={normalizeMediaUrl(badgde, 'image')} alt="Completion badge" />
                    <div className='badgde-btn'>
                        <button className='download-badgde' onClick={() => downloadBadge(badgde)}>Download Badge</button>
                        <button className='share-linkdin' onClick={() => shareOnLinkedIn(badgde)}>Share On LinkedIn</button>
                    </div>
                </Modal.Body>
            </Modal>


        </>
    );
}

export default MicroCerts;
